import client from 'services/networking/client';
import type { Casting } from 'shared-types/casting';
import type { PlayerEvent } from 'shared-types/player-event';

export const getCasting = async (): Promise<Casting> => {
  const response = await client.get('/casting');
  return response;
};

export const postCastingEvent = async (
  castingSessionId: string,
  event: PlayerEvent,
  data: string | null = '',
): Promise<Casting> => {
  const response = await client.post(`/casting/${castingSessionId}`, {
    event,
    data,
  });
  return response;
};

export const getCastingSessionEventSource = (castingSessionId: string): EventSource => {
  const sseUrl = process.env.REACT_APP_MERCURE_BASE_URL;

  if (!sseUrl) {
    throw new Error(`SSE subscription URL missing. Current value: ${sseUrl}`);
  }

  const castingUrl = new URL(sseUrl as string);
  const topicUrl = `${process.env.REACT_APP_API_BASE_URL}/casting/${castingSessionId}`;

  castingUrl.searchParams.append('topic', topicUrl);

  return new EventSource(castingUrl.toString());
};
